import { IMAGE_TYPE, VIDEO_TYPE, FILE_UPLOAD_TYPE, GALLERY_TYPE, GIPHY_TYPE, AUDIO_TYPE, } from 'wix-rich-content-common';
export const PLUGIN_CONFIG_DEFAULTS = (internalProps) => ({
    mention: {
        onMentionHover: (mention, ref) => {
            var _a;
            (_a = internalProps === null || internalProps === void 0 ? void 0 : internalProps.setHoverMentionData) === null || _a === void 0 ? void 0 : _a.call(internalProps, { mention, ref });
        },
    },
    [IMAGE_TYPE]: {},
    [GIPHY_TYPE]: {
        giphySdkApiKey: 'HLX7ZyF2g6G0dI3S1S4RdgjMtn9Zj1VR',
        componentDataDefaults: { config: { size: 'small', alignment: 'center' } },
    },
});
export const PLUGIN_CONFIG_OVERRIDES = (internalProps) => ({});
export const DISABLED_PLUGIN_TYPES_FOR_GUESTS = [
    GALLERY_TYPE,
    FILE_UPLOAD_TYPE,
    VIDEO_TYPE,
    IMAGE_TYPE,
    AUDIO_TYPE,
];
//# sourceMappingURL=plugins.js.map